<template>
  <div class="chart" :style="{ height: height }" />
</template>

<script>
//import { echarts } from "echarts";
import * as echarts from "echarts";
require("echarts/theme/shine"); // echarts theme

const tradingVolumeData = require("../../data/trading/tradingVolumeData.json");

export default {
  props: [
    "meter",
    "current",
    "vectors",
    "contract",
    "projectedConsumption",
    "start",
  ],
  data() {
    return {
      chart: null,
      sidebarElm: null,
      height: "450px",
      autoResize: true,
      meters: this.$props.meter,
      months: {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      },

      tradingVolume: [],
      totalRequests: 0,
      totalOffers: 0,
    };
  },
  mounted() {
    this.initChart("BGDSO01","073","2021");

    if (this.autoResize) {
      this.__resizeHandler = this.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener("resize", this.__resizeHandler);
    };
    this.$nextTick(function () {
      this.getTradingVolumeData(this.selectedZone,this.selectedLocation,this.selectedYear);
        // Code that will run only after the entire view has been rendered
    });
    this.$root.$on("getTradingVolumeData", (selectedZone,selectedLocation,selectedYear) => {
      console.log("HERE... test call method getTradingVolumeData of TradingVolumeChart with: "
                      +selectedZone, selectedLocation, selectedYear);
      return this.initChart(selectedZone,selectedLocation,selectedYear);
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }
    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === "width") {
        this.__resizeHandler();
      }
    },
    setOptions() {
      this.chart.setOption({
        animationDuration: 5000,
        smooth: true,
        xAxis: {
          type: "category",
          data: ["Q1", "Q2", "Q3", "Q4"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            //data: [50, 135, 112, 144],
            data: [
              this.tradingVolume[0][0].avgTradingPrice,
              this.tradingVolume[0][1].avgTradingPrice,
              this.tradingVolume[0][2].avgTradingPrice,
              this.tradingVolume[0][3].avgTradingPrice,
            ],
            type: "line",
            lineStyle: { color: "#79cd89" },
            itemStyle: { color: "#79cd89" },
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(121,205,137,0.8)",
                },
                {
                  offset: 1,
                  color: "rgba(242,250,250,0.3)",
                },
              ]),
            },
          },
          {
            data: [70, 60, 50, 70],
            type: "line",
            lineStyle: { color: "#dadada" },
            itemStyle: { color: "#dadada" },
            smooth: true,
          },
        ],
      });
    },
    initChart(zoneCode,locationCode,yearCode) {
      this.getTradingVolumeData(zoneCode,locationCode,yearCode);
      this.chart = echarts.init(this.$el, "shine");
      this.setOptions();
    },
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // According to the last trigger interval
        const last = new Date().getTime() - timestamp;
        // The last time the wrapped function was called, the interval is last less than the set time interval wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) {
              context = args = null;
            }
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = new Date().getTime();
        const callNow = immediate && !timeout;
        // If the delay does not exist, reset the delay
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }
        return result;
      };
    },
    getTradingVolumeData(zoneCode, locationCode, yearCode) {
        //console.log("HERE... consumptions data: " + consumptionsData.toString());
        this.tradingVolume = [];
        this.totalRequests = 0;
        this.totalOffers = 0;
      
        for (var i = 0; i < tradingVolumeData.length; i++) {
            if (tradingVolumeData[i].zoneCode == zoneCode 
                && tradingVolumeData[i].locationCode == locationCode
                && tradingVolumeData[i].yearCode == yearCode) {
              this.tradingVolume.push(tradingVolumeData[i].tradingVolume);
            }
        }
    
        console.log("HERE... trading volume data: " + this.tradingVolume.toString(), "length: " + this.tradingVolume[0].length);

        for (var i = 0; i < this.tradingVolume[0].length; i++) {
          this.totalRequests = this.totalRequests + this.tradingVolume[0][i].totalRequests
          this.totalOffers = this.totalOffers + this.tradingVolume[0][i].totalOffers
        }
        
        console.log("HERE... totalRequests: " + this.totalRequests + " totalOffers: " + this.totalOffers);
    },
  },

  updated() {
    // Fired every second, should always be true
    this.tradingVolume;
    console.log("HERE... trading volume data: " + this.tradingVolume.toString());
  },
};
</script>